// extracted by mini-css-extract-plugin
module.exports = {"AllergenIcon":"index-module--AllergenIcon--3WJMJ","RTL":"index-module--RTL--_LhAA"};